import { ReactElement } from "react"
import { Option } from "./Option"

export interface OptGroupProps {
  children: ReactElement<typeof Option> | ReactElement<typeof Option>[]
  disabled?: boolean
  label: string
}

const OptGroup = ({ children, disabled = false, label }: OptGroupProps) => {
  return (
    <optgroup label={label} disabled={disabled}>
      {children}
    </optgroup>
  )
}

OptGroup.displayName = "Select.OptGroup"

export { OptGroup }
